function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function shouldNotConvert(value) {
  return value === undefined || value === null || value === true || value === false;
}

var convertKeyToLowerCase = function convertKeyToLowerCase(object) {
  if (object) {
    var convertedObj = Object.keys(object).reduce(function (acc, key) {
      if (shouldNotConvert(acc[key])) {
        return acc;
      }

      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, acc[key].toString().toLowerCase()));
    }, object);
    return convertedObj;
  }

  return object;
};

var omitObjectKey = function omitObjectKey(object, omitKey) {
  var result = Object.keys(object).reduce(function (acc, key) {
    if (Object.prototype.hasOwnProperty.call(object, key) && key !== omitKey) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, object[key]));
    }

    return acc;
  }, {});
  return result;
};

var uniqueConcat = function uniqueConcat(firstArray, secondArray) {
  var availableSizes = firstArray.reduce(function (acc, value) {
    if (acc.indexOf(value) === -1) {
      acc.push(value);
    }

    return acc;
  }, secondArray);
  return availableSizes.join(',');
};

var mergeOverrideValues = function mergeOverrideValues(values, overrides) {
  if (overrides === undefined) {
    return values;
  }

  var valueKeys = Object.keys(values);
  Object.keys(overrides).forEach(function (key) {
    if (valueKeys.indexOf(key) > -1) {
      values[key] = overrides[key];
    }
  });
  return values;
};

var turnParamsIntoUrl = function turnParamsIntoUrl(params, blackList) {
  var url = '';
  var paramKeys = Object.keys(params).sort();

  for (var i = 0; i < paramKeys.length; i += 1) {
    var paramKey = paramKeys[i];

    if (blackList.indexOf(paramKey) < 0) {
      var paramValue = params[paramKey];

      if (paramValue !== null && paramValue !== undefined) {
        var tagValue = '';

        if (typeof paramValue === 'string') {
          tagValue = paramValue.indexOf('|') ? paramValue.replace(/\|/g, ',') : paramValue;
        } else {
          tagValue = paramValue;
        }

        url += "/".concat(paramKey, "=").concat(tagValue);
      }
    }
  }

  return url;
};

export { convertKeyToLowerCase, omitObjectKey, uniqueConcat, mergeOverrideValues, turnParamsIntoUrl };
//# sourceMappingURL=convertObject.js.map